module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-selectize-vehicle"
  }, [(_vm.options) ? _c('selectize', {
    ref: "selectize",
    attrs: {
      "selectedValue": _vm.selectedValue,
      "options": _vm.options,
      "value-field": "id",
      "maxItems": _vm.maxItems,
      "label-field": "Intervention request",
      "items": _vm.items,
      "searchField": _vm.searchableFields,
      "optionTemplate": _vm.optionTemplate,
      "disabled": _vm.disabled,
      "renderTemplate": _vm.renderTemplate,
      "placeholder": "Intervention requests"
    },
    on: {
      "itemAdded": _vm.optionSelected,
      "itemRemoved": _vm.optionRemoved
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-46ff27db!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/lists/selectize/SelectizeInterventionRequest.vue
// module id = 2462
// module chunks = 1